import { ThemeEvents } from '@theme/events';

/**
 * PDP multibuy message. The offer is rendered by snippets/multibuy-offer.liquid
 * for the selected variant, and is omitted when that variant is on sale.
 * A variant change re-renders the section, so this swaps in that copy and
 * hides the block when the new variant has no message. 
 */
class ProductMultibuyMessaging extends HTMLElement {
  /** @type {string|null} */
  #lastProcessedSourceId = null;

  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (closestSection) {
      closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateMessage);
    }
    document.addEventListener(ThemeEvents.variantUpdate, this.updateMessage);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (closestSection) {
      closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateMessage);
    }
    document.removeEventListener(ThemeEvents.variantUpdate, this.updateMessage);
  }

  /**
   * @param {import('@theme/events').VariantUpdateEvent} event
   */
  updateMessage = (event) => {
    const incomingSourceId = event.detail?.sourceId;
    if (incomingSourceId && incomingSourceId === this.#lastProcessedSourceId) return;
    this.#lastProcessedSourceId = incomingSourceId ?? null;
    if (incomingSourceId) {
      queueMicrotask(() => {
        if (this.#lastProcessedSourceId === incomingSourceId) this.#lastProcessedSourceId = null;
      });
    }

    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const html = event.detail.data.html;
    if (!html) return;

    const updated = html.querySelector(
      `product-multibuy-messaging[data-block-id="${this.dataset.blockId}"]`
    );
    if (!updated) return;

    this.innerHTML = updated.innerHTML;
    if (updated.hasAttribute('hidden')) {
      this.setAttribute('hidden', '');
    } else {
      this.removeAttribute('hidden');
    }
  };
}

if (!customElements.get('product-multibuy-messaging')) {
  customElements.define('product-multibuy-messaging', ProductMultibuyMessaging);
}
